module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "monitor"
  }, [_c('v-header', {
    attrs: {
      "name": _vm.name,
      "isDashboard": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('div', {
    staticClass: "item",
    on: {
      "click": _vm.up
    }
  }, [_c('span', {
    staticClass: "monitor-name",
    staticStyle: {
      "margin-right": "30px"
    }
  }, [_vm._v("百色市田阳县气象监控站")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "options"
  }, _vm._l((_vm.options), function(item, index) {
    return _c('div', {
      key: item.id
    }, [_vm._v("\n            " + _vm._s(item.text) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "item item1"
  }, [_c('span', [_vm._v(_vm._s(_vm.listData[_vm.num].temperature) + "°C")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "item item1"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require("../../../assets/img/monitor/1.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("湿度" + _vm._s(_vm.listData[_vm.num].humidity) + "%")])]), _vm._v(" "), _c('span', [_c('img', {
    attrs: {
      "src": require("../../../assets/img/monitor/2.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("西南风 " + _vm._s(_vm.listData[_vm.num].winds) + " 级")])])]), _vm._v(" "), _c('div', {
    staticClass: "item item1"
  }, [_vm._m(2), _vm._v(" "), _c('span', [_c('img', {
    attrs: {
      "src": require("../../../assets/img/monitor/3.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("空气指数: " + _vm._s(_vm.listData[_vm.num].air))])])])]), _vm._v(" "), _vm._m(3)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('span', {
    staticClass: "time"
  }, [_vm._v("16：00 更新")]), _vm._v(" "), _c('img', {
    staticClass: "down-arrow",
    attrs: {
      "src": require("../../../assets/img/monitor/5.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('span', [_vm._v("晴")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../assets/img/monitor/8.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('span', {
    staticClass: "index-mark"
  }, [_vm._v("优")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "detail-item"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v("土壤温度")]), _vm._v(" "), _c('p', {
    staticClass: "data"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("24")]), _c('span', {
    staticClass: "unit"
  }, [_vm._v("℃")])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-item"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v("土壤湿度")]), _vm._v(" "), _c('p', {
    staticClass: "data"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("43")]), _c('span', {
    staticClass: "unit"
  }, [_vm._v("%")])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-item"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v("水质PH")]), _vm._v(" "), _c('p', {
    staticClass: "data"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("6.9")]), _c('span', {
    staticClass: "unit"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "detail-item"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v("水质温度")]), _vm._v(" "), _c('p', {
    staticClass: "data"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("23")]), _c('span', {
    staticClass: "unit"
  }, [_vm._v("℃")])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-item"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v("CO2浓度")]), _vm._v(" "), _c('p', {
    staticClass: "data"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("453")]), _c('span', {
    staticClass: "unit"
  }, [_vm._v("ppm")])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-item"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v("PM2.5")]), _vm._v(" "), _c('p', {
    staticClass: "data"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("13")]), _c('span', {
    staticClass: "unit"
  }, [_vm._v("ug/m²")])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-item"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v("土壤铵根离子")]), _vm._v(" "), _c('p', {
    staticClass: "data"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1.0")]), _c('span', {
    staticClass: "unit"
  }, [_vm._v("ppm")])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-item"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v("土壤硝酸离子")]), _vm._v(" "), _c('p', {
    staticClass: "data"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("0")]), _c('span', {
    staticClass: "unit"
  }, [_vm._v("ppm")])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-item"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v("土壤钾离子")]), _vm._v(" "), _c('p', {
    staticClass: "data"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("41.93")]), _c('span', {
    staticClass: "unit"
  }, [_vm._v("ppm")])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-item"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v("铜离子")]), _vm._v(" "), _c('p', {
    staticClass: "data"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("0.01")]), _c('span', {
    staticClass: "unit"
  }, [_vm._v("ppm")])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-item"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v("铅离子")]), _vm._v(" "), _c('p', {
    staticClass: "data"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("0.3")]), _c('span', {
    staticClass: "unit"
  }, [_vm._v("ppm")])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-item"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v("镉离子")]), _vm._v(" "), _c('p', {
    staticClass: "data"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("0.01")]), _c('span', {
    staticClass: "unit"
  }, [_vm._v("ppm")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d52ad3dc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/runda/environmentMonitor/index.vue
// module id = 2089
// module chunks = 2